import { render, staticRenderFns } from "./positive-action-button.vue?vue&type=template&id=3c5d7251&scoped=true"
import script from "./positive-action-button.vue?vue&type=script&lang=js"
export * from "./positive-action-button.vue?vue&type=script&lang=js"
import style0 from "./positive-action-button.vue?vue&type=style&index=0&id=3c5d7251&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d7251",
  null
  
)

export default component.exports